import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import type { TeamMemberData } from '@core/tellent-assistant-types';
import { AppKind } from '@core/tellent-types';

import { injectAssistantEntityUrl } from '../../assistant-entity-url';
import { ListCardComponent } from '../../list-card/list-card.component';
import { ListRowPersonComponent } from '../../rows/list-row-person.component';

@Component({
  selector: 'rt-list-item-team-member',
  imports: [ListCardComponent, ListRowPersonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <rt-assistant-list-card [url]="url()" [label]="data().name">
      <rt-list-row-person [data]="data()" />
    </rt-assistant-list-card>
  `,
})
export class ListItemTeamMemberComponent {
  private readonly entityUrl = injectAssistantEntityUrl();

  protected readonly url = computed(() =>
    this.entityUrl(AppKind.TellentAdmin, { id: 'team_members' }),
  );

  public readonly data = input.required<TeamMemberData>();
}
